<template>
  <v-toolbar
    id="core-toolbar"

    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <!-- <v-text-field
          v-if="responsiveInput"
          class="mr-4 mt-2 green-input"
          label="Search..."
          hide-details
          color="purple"
        /> -->
        <!-- <router-link
          v-ripple
          class="toolbar-items"
          to="/"
        >
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link> -->
        <v-menu
          bottom
          left
          content-class="dropdown-menu"
          offset-y
          transition="slide-y-transition">
          <router-link
            v-ripple
            slot="activator"
            class="toolbar-items"
            to="#"
          >        
          <v-icon color="tertiary">mdi-account</v-icon>  Profile       
          </router-link>

          <v-card>
            <v-list dense>
           
             <!-- <v-list-tile avatar class="v-list-item" :to="'/dashboard'" :active-class="color">
              <v-list-tile-action >
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-tile-action>
              <v-list-tile-title
                v-text="'Dashboard'"
              />
            </v-list-tile> -->
           
             <v-list-tile avatar class="v-list-item"  :to="'/change-password'" >
              <v-list-tile-action >
                <v-icon>mdi-lock-reset</v-icon>
              </v-list-tile-action>
              <v-list-tile-title
                v-text="'Change Password'"
              />
            </v-list-tile>
            
             <v-list-tile avatar class="v-list-item"  @click.prevent="signout">
              <v-list-tile-action >
                <v-icon>mdi-logout</v-icon>
              </v-list-tile-action>
              <v-list-tile-title
                v-text="'Sign out'"
              />
            </v-list-tile>

            </v-list>
          </v-card>
          
        </v-menu>
        <!-- <a
          v-ripple
          class="toolbar-items"
          href="#"
          @click.prevent="signout"
        >
          Sign out
        </a> -->
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import {
  mapMutations
} from 'vuex'

export default {
  data: () => ({
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      'You\'re now a friend with Andrew',
      'Another Notification',
      'Another One'
    ],
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    signout () {
        var value = '; ' + document.cookie
        var info = value.split('; ' + 'Info' + '=')
        var d = new Date()
        d.setTime(d.getTime())
        var expires = 'expires=' + d.toUTCString()
        document.cookie = 'Token=' + '' + ';' + expires + ';path=/'
        document.cookie = 'Info=' + '' + ';' + expires + ';path=/'
        this.$router.push('/login')
    }
  }
}
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
  .dropdown-menu {border-radius: 3px;z-index: 9999 !important;}  
  .v-list__tile__action{
        min-width: 40px !important;
  }
</style>
